import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://xn--kilpnrmekliinik-4kba.ee';

// Pages that should NOT be indexed (auth-required)
const NOINDEX_PATHS = ['/dashboard', '/doctor/dashboard', '/results', '/payment', '/reset-password', '/admin'];

// The hreflang alternates baked into index.html describe the HOMEPAGE only.
// Left in place on other routes they tell Google that "/" is the alternate of
// e.g. /blog/hypothyroidism, which makes Google discard the hreflang cluster
// (and previously caused "Alternate page with proper canonical tag" in GSC).
// We keep the nodes in memory and attach/detach them per route.
let globalAlternates = null;
const getGlobalAlternates = () => {
  if (!globalAlternates) {
    globalAlternates = Array.from(
      document.querySelectorAll('link[rel="alternate"][data-global-hreflang]')
    );
  }
  return globalAlternates;
};

export function useCanonical() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const canonicalEl = document.querySelector('link[rel="canonical"]');
    const robotsEl = document.querySelector('meta[name="robots"]');

    // Homepage keeps the global alternates; every other route drops them.
    getGlobalAlternates().forEach((node) => {
      if (path === '/') {
        if (!node.isConnected) document.head.appendChild(node);
      } else if (node.isConnected) {
        node.remove();
      }
    });

    // Check if current path should be noindexed
    const shouldNoIndex = NOINDEX_PATHS.some(p => path.startsWith(p));
    // A page (e.g. the 404 view) can claim noindex for itself; respect it.
    const lockedByPage = robotsEl?.hasAttribute('data-noindex-lock');

    if (shouldNoIndex) {
      // Block indexing for auth-protected pages
      if (robotsEl) {
        robotsEl.setAttribute('content', 'noindex, nofollow');
      }
    } else if (!lockedByPage) {
      // Restore indexing for public pages
      if (robotsEl) {
        robotsEl.setAttribute('content', 'index, follow');
      }
      // Set canonical to match current page
      if (canonicalEl) {
        const canonicalUrl = path === '/' ? `${BASE_URL}/` : `${BASE_URL}${path}`;
        canonicalEl.setAttribute('href', canonicalUrl);
      }
    }

    return () => {
      // Reset canonical on unmount
      if (canonicalEl) {
        canonicalEl.setAttribute('href', `${BASE_URL}/`);
      }
      if (robotsEl && !robotsEl.hasAttribute('data-noindex-lock')) {
        robotsEl.setAttribute('content', 'index, follow');
      }
    };
  }, [location.pathname]);
}
